export function decodeBase64Svg(icon: string): string | null {
  if (!icon?.startsWith("data:image/svg+xml;base64,")) {
    return null;
  }

  try {
    const base64 = icon.replace("data:image/svg+xml;base64,", "");
    return atob(base64);
  } catch (e) {
    console.error("Invalid base64 SVG:", e);
    return null;
  }
}

export function resolveIconSource(icon: string): string {
  if (/^https?:\/\//.test(icon)) {
    return icon;
  }

  if (icon?.startsWith("data:image/svg+xml;base64,")) {
    return icon;
  }

  return `data:image/svg+xml;base64,${icon}`;
}
